// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";
import { loginAPI } from "../api/auth";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initializing, setInitializing] = useState(true); // ✅ NEW: Track initial auth check
  const [token, setToken] = useState(null);

  // Restore user + tokens from localStorage on app start
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedAccess = localStorage.getItem("accessToken");
    const storedRefresh = localStorage.getItem("refreshToken");

    if (storedUser && storedAccess) {
      try {
        setUser(JSON.parse(storedUser));
        setToken({
          access: storedAccess,
          refresh: storedRefresh,
        });
      } catch (error) {
        console.error("Error parsing stored user:", error);
        // Clear corrupted data
        localStorage.removeItem("user");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
      }
    }
    
    setInitializing(false); // ✅ Auth check complete
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const data = await loginAPI(email, password);
      // data: { access, refresh, id, email, name }
      const userInfo = {
        id: data.id,
        email: data.email,
        name: data.name,
      };

      setUser(userInfo);
      setToken({ access: data.access, refresh: data.refresh });

      // persist in localStorage
      localStorage.setItem("user", JSON.stringify(userInfo));
      localStorage.setItem("accessToken", data.access);
      localStorage.setItem("refreshToken", data.refresh);

      return true;
    } catch (error) {
      console.error("Login failed:", error.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, initializing }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}